import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { Card } from '@salesforce/design-system-react';

import { DateRange } from '../../../common/components/';

import rangeOptionValues from '../../../common/constants/dateRangeOptionValues';

import './ReportsFilter.scss';

class ReportsFilter extends Component {
  /**
   * Date Range
   */
  handleDateRangeChange(selection) {
    if (selection.selectedDate) {
      this.props.actions.modifyReportsFilter({
        ...this.props.filter,
        ...selection.selectedDate
      });
    }
  }

  render() {
    const { formatMessage } = this.props.intl;
    return (
      <div className="reports-filter">
        <Card hasNoHeader>
          <div className="slds-grid">
            <div className="slds-col slds-grow-none slds-col_bump-left">
              <DateRange
                label={formatMessage({
                  id: 'components.ecs.analytics.filter.daterRangeLabel'
                })}
                selectedRange={rangeOptionValues.LAST_7_DAYS}
                onDateRangeChange={this.handleDateRangeChange.bind(this)}
              />
            </div>
          </div>
        </Card>
      </div>
    );
  }
}

ReportsFilter.propTypes = {
  filter: PropTypes.object,
  actions: PropTypes.object.isRequired,
  location: PropTypes.object
};

export default injectIntl(ReportsFilter);
